import { useTypedSelector } from "../selectors.utils";
import { RelationshipsModel } from "../../../models/responses/relationships.model";
import {getRelationshipsForSpecificTask} from "./relationships.selectors.utils";

// Relations
export const useRelationshipsSelector = (taskId: string) => {
    const relationshipsList = useTypedSelector<RelationshipsModel[]>(state => state.relationships.relationshipsList);
    return getRelationshipsForSpecificTask(relationshipsList, taskId)
};
